module.exports = __webpack_public_path__ + "img/636721847336679788depri-overzicht2.png";